import React, { Component } from "react";
import { Text, View } from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  featuredArticle,
  homeCover,
  FontFamily,
  articleLists,
  Colors,
} from "../../styles/appStyles";
import CustomImage from "../custom-image";
import { helpers } from "../../utils/helpers";
import TouchableOpacityLink from "../touchable-opacity-link";
import moment from "moment";
import Cookies from "universal-cookie";
import { Mixpanel } from "../../utils/mixpanel";
import AuthenticationWrapper from "../authentication-wrapper";

const cookies = new Cookies();

export class HomeFeaturedStory extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    const { isAuthenticated, fetchToken } = this.props.auth;
    let token = webView
      ? process.browser
        ? isAuthenticated
          ? fetchToken
          : false
        : this.props.token
      : this.props.user?.userData?.data?.token;
    this.state = {
      showToken: !helpers.isWeb() || process.browser ? true : false,
    };
  }

  componentDidMount = () => {};

  trackCateoryClick = (item) => {
    // try {
    //     Mixpanel.track('category', {category_slug: item.category.slug, source_section_type: 'home_featured_story', section_value: { title : item.name, slug: item.slug } });
    // }
    // catch(error) {
    //     console.log("mix panel error =>", error);
    // }
  };

  render() {
    const {
      data,
      require,
      viewArticle,
      viewCategory,
      viewAuthor,
      lazyLoad,
      hideDate,
      darkMode,
    } = this.props;

    let categoryClick, btnClick, authorBtnClick, authorBtn2Click;
    if (helpers.isWeb()) {
      categoryClick = {
        to: "/category/" + data.category.slug,
      };
      btnClick = {
        to: {
          pathname: "/" + data.category.slug + "/" + data.slug,
          postData: data,
        },
      };
      authorBtnClick = {
        to: "/writers/" + data.author[0].slug,
      };
      if (data.author[1]) {
        authorBtn2Click = {
          to: "/writers/" + data.author[1].slug,
        };
      }
    } else {
      categoryClick = {
        onPress: (event) => {
          event.stopPropagation();
          viewCategory(data.category.slug);
        },
      };
      btnClick = {
        onPress: () => {
          viewArticle(data.category.slug, data.slug, data);
        },
      };
      authorBtnClick = {
        onPress: (event) => {
          event.stopPropagation();
          viewAuthor(data.author[0].slug);
        },
      };
      if (data.author[1]) {
        authorBtn2Click = {
          onPress: (event) => {
            event.stopPropagation();
            viewAuthor(data.author[1].slug);
          },
        };
      }
    }

    return (
      <View
        style={[
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWebFull,
          helpers.isDesktop() && {
            marginTop: 50,
            marginLeft: "auto",
            marginRight: "auto",
          },
          !helpers.isDesktop() && { marginBottom: 90 },
          darkMode && { backgroundColor: Colors.darkBlackColorBg },
        ]}
      >
        <TouchableOpacityLink {...btnClick}>
          {helpers.isWeb() && (
            <View
              style={[
                featuredArticle.borderLine,
                helpers.isDesktop() && featuredArticle.borderLineDesktop,
              ]}
            ></View>
          )}
        </TouchableOpacityLink>
        <TouchableOpacityLink {...btnClick}>
          <View
            style={[
              helpers.isDesktop() && Padding.ph_2,
              Margin.mb_3,
              helpers.isDesktop() && Flex.row,
              { position: "relative" },
              helpers.isDesktop() && { alignItems: "center" },
              process.browser && { zIndex: "auto" },
            ]}
          >
            <View>
              <CustomImage
                source={data.featured_image.url}
                require={require}
                style={{
                  width: "100%",
                  height: 295,
                  zIndex: -99,
                }}
                webStyle={{
                  width: helpers.isDesktop() ? 450 : "100%",
                  height: helpers.isDesktop() ? 650 : 295,
                  objectFit: "cover",
                }}
                resizeMode={"cover"}
                altText={
                  data.featured_image.alt && data.featured_image.alt != ""
                    ? data.featured_image.alt
                    : data.title
                    ? data.title
                    : data.story?.title
                    ? data.story.title
                    : data.featured_image.title
                }
                lazyLoad={lazyLoad ? true : false}
              />
            </View>
            <View
              style={[
                Padding.ph_2,
                { marginHorizontal: helpers.isDesktop() ? 30 : 24 },
                helpers.isDesktop() && { width: "45%" },
                !helpers.isDesktop() && { marginTop: 20 },
                { zIndex: 9 },
              ]}
            >
              <View style={[Margin.mb_2]}>
                <View style={[Flex.fill]}>
                  <TouchableOpacityLink
                    {...categoryClick}
                    handleClick={() => this.trackCateoryClick(data)}
                  >
                    <Text
                      style={[
                        Margin.mt_0,
                        Margin.mb_0,
                        Helpers.textUppercase,
                        { marginTop: 6 },
                        [
                          articleLists.badge,
                          {
                            textAlign: "left",
                            fontFamily: FontFamily.regular,
                            color: "#907cff",
                            letterSpacing: helpers.isDesktop() ? 1 : 0.5,
                            fontSize: 20,
                            lineHeight: 24,
                          },
                        ],
                        !helpers.isDesktop() && {
                          fontSize: 15,
                          lineHeight: 18,
                        },
                        !helpers.isWeb() && { fontFamily: FontFamily.semiBold },
                        darkMode && { color: "#5263F4" },
                      ]}
                    >
                      {data.category.name}
                    </Text>
                  </TouchableOpacityLink>
                </View>
                <View style={[Flex.fill]}>
                  <Text
                    style={[
                      Margin.mt_0,
                      Margin.mb_0,
                      homeCover.heading,
                      helpers.isDesktop() && homeCover.headingDesktop,
                      !helpers.isDesktop() && { fontSize: 30 },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    {data.title}
                  </Text>
                </View>
              </View>
              <View
                style={[
                  Flex.row,
                  {
                    flexWrap: "wrap",
                    height: helpers.isWeb() ? "fit-content" : "auto",
                  },
                ]}
              >
                <View
                  style={[Margin.mb_2, { maxWidth: "100%", width: "auto" }]}
                >
                  <Text
                    style={[
                      homeCover.content,
                      helpers.isDesktop() && homeCover.contentDesktop,
                      {
                        maxWidth: "100%",
                        color: "#000",
                        fontSize: helpers.isDesktop() ? 20 : 16,
                        lineHeight: helpers.isDesktop() ? 30 : 26,
                      },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    {data.strapline ? data.strapline : data.excerpt}
                  </Text>
                </View>
                <View style={[featuredArticle.lineBreak]} />
                <View
                  style={[
                    postSingle.authorDetailsWrap,
                    Margin.mt_2,
                    helpers.isDesktop() && Flex.justifyStart,
                    { width: "100%", flexWrap: "wrap" },
                    !helpers.isDesktop() && Flex.column,
                    !helpers.isDesktop() && Flex.alignStart,
                  ]}
                >
                  <TouchableOpacityLink {...authorBtnClick}>
                    <View
                      style={[
                        postSingle.authorDetailsWrap,
                        helpers.isDesktop() && Flex.justifyStart,
                      ]}
                    >
                      <View
                        style={[
                          postSingle.authorPicWrap,
                          {
                            width: helpers.isDesktop() ? 44 : 40,
                            height: helpers.isDesktop() ? 44 : 40,
                          },
                        ]}
                      >
                        <CustomImage
                          source={data.author[0].profile_image}
                          require={false}
                          webStyle={{
                            width: helpers.isDesktop() ? 40 : 36,
                            height: helpers.isDesktop() ? 40 : 36,
                            borderRadius: 100,
                          }}
                          resizeMode={"contain"}
                          style={postSingle.authorThumb}
                          altText={data.author[0].name}
                        />
                      </View>
                      <View style={[Padding.pl_1]}>
                        <Text
                          style={[
                            postSingle.authorName,
                            helpers.isDesktop() && postSingle.authorNameDesktop,
                            { fontSize: 18 },
                            !helpers.isDesktop() && {
                              marginBottom: 0,
                              fontSize: 15,
                            },
                            darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                          ]}
                        >
                          {data.author[0].name}
                        </Text>
                      </View>
                    </View>
                  </TouchableOpacityLink>
                  {data.author[1] && (
                    <>
                      {helpers.isDesktop() && !hideDate && (
                        <View style={[featuredArticle.dotSeprator]} />
                      )}
                      <TouchableOpacityLink {...authorBtn2Click}>
                        <View
                          style={[
                            postSingle.authorDetailsWrap,
                            Flex.alignCenter,
                            Flex.justfiyCenter,
                            helpers.isDesktop() && Flex.justifyStart,
                            { paddingVertical: 15 },
                          ]}
                        >
                          <View
                            style={[
                              postSingle.authorPicWrap,
                              {
                                width: helpers.isDesktop() ? 44 : 40,
                                height: helpers.isDesktop() ? 44 : 40,
                              },
                            ]}
                          >
                            <CustomImage
                              source={data.author[1].profile_image}
                              require={false}
                              webStyle={{
                                width: helpers.isDesktop() ? 40 : 36,
                                height: helpers.isDesktop() ? 40 : 36,
                                borderRadius: 100,
                              }}
                              resizeMode={"contain"}
                              style={postSingle.authorThumb}
                              altText={data.author[1].name}
                            />
                          </View>
                          <View style={[Padding.pl_1]}>
                            <Text
                              style={[
                                postSingle.authorName,
                                helpers.isDesktop() &&
                                  postSingle.authorNameDesktop,
                                !helpers.isDesktop() && { fontSize: 15 },
                                darkMode && {
                                  color: "rgba(255, 255, 255, 0.89)",
                                },
                              ]}
                            >
                              {data.author[1].name}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacityLink>
                    </>
                  )}
                  {helpers.isDesktop() && !hideDate && (
                    <View style={[featuredArticle.dotSeprator]} />
                  )}
                  {!hideDate && (
                    <Text
                      style={[
                        featuredArticle.postDate,
                        helpers.isDesktop() && featuredArticle.postDateDesktop,
                        { fontSize: 16 },
                        !helpers.isDesktop() && {
                          position: "absolute",
                          left: 50,
                          top: 22,
                          fontSize: 13,
                        },
                        darkMode && { color: "rgba(255, 255, 255, 0.6)" },
                      ]}
                    >
                      {moment(data.published_date).format("DD MMMM, YYYY")}
                    </Text>
                  )}
                </View>
              </View>
            </View>
          </View>
          {!helpers.isWeb() && (
            <View
              style={[
                featuredArticle.borderLine,
                helpers.isDesktop() && featuredArticle.borderLineDesktop,
                { width: "92%", left: 15, flex: 1, zIndex: -1 },
              ]}
            ></View>
          )}
        </TouchableOpacityLink>
      </View>
    );
  }
}

export default AuthenticationWrapper(HomeFeaturedStory);
